import ApiService from "../../../../services/ApiService";
import { getAgeHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";

export const fetchMeetingLogsDetailed = (
  meetingId: string,
  setMeetingLogs: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);
  ApiService.get(`meetings/${meetingId}/logs/detailed`)
    .then((response) =>
      setMeetingLogs(
        response.data.meeting_logs.map((log: any) => ({
          ...log,
          date: getAgeHumanly(language, log.timestamp, true),
        }))
      )
    )
    .catch((error) => {
      console.error("Error fetching meeting detailed logs:", error);
      alert(translate(language, "PAGES.MEETING.ERRORS.FETCH_MEETING_DETAILED_LOGS"));
    })
    .finally(() => setLoaded(true));
};
